<div class="min-h-screen flex">

  <!-- Panel izquierdo — solo escritorio -->
  <div class="hidden lg:flex lg:w-1/2 relative overflow-hidden bg-gray-900 flex-col">

    <!-- Fondo fotográfico con blur -->
    <img ngSrc="/img/background.png" width="1200" height="1800" alt=""
      class="absolute inset-0 h-full w-full object-cover scale-105 blur-xs" priority />

    <!-- Capas para contraste -->
    <div class="absolute inset-0 bg-white/10"></div>
    <div class="absolute inset-0 bg-linear-to-t from-black/70 via-black/10 to-black/5"></div>

    <!-- Contenido -->
    <div class="relative z-10 flex h-full flex-col">

    <!-- Logo -->
    <div class="flex justify-start px-8 pt-8">
      <!-- <div class="bg-white rounded-xl border border-gray-200 px-6 py-3 inline-flex items-center justify-center shadow-md"> -->
        <img ngSrc="/img/logo.png" width="640" height="480" alt="Tramitex"
          class="h-24 w-auto" priority />
      <!-- </div> -->
    </div>

    <!-- Texto de marketing -->
    <div class="flex-1 flex flex-col justify-end px-8 pb-16">
      <h1 class="text-2xl font-bold text-white leading-snug">
        Simplifica tu gestoría gubernamental
      </h1>
      <p class="text-gray-200/80 mt-3 text-sm leading-relaxed">
        Plataforma integral para gestores y consultores. Administra trámites,
        clientes y documentos en un solo lugar.
      </p>
    </div>

    <!-- Footer -->
    <div class="p-7">
      <p class="text-gray-300/90 text-xs">© 2026 Tramitex. Todos los derechos reservados.</p>
    </div>

    </div>
  </div>

  <!-- Panel derecho -->
  <div class="w-full lg:w-1/2 flex items-center justify-center bg-gray-50 min-h-screen p-6">
    <div class="w-full max-w-lg">

      <!-- Tarjeta de formulario -->
      <div class="bg-white rounded-2xl shadow-sm border border-gray-200 p-12">

        <!-- Logo — solo móvil -->
        <div class="flex justify-center mb-8 lg:hidden">
          <img ngSrc="/img/logo.png" width="640" height="480" alt="Tramitex"
            class="h-20 w-auto" priority />
        </div>

        <h2 class="text-2xl font-bold text-gray-900 mb-1">Bienvenido</h2>
        <p class="text-sm text-gray-500 mb-6">Ingresa tus credenciales para acceder a tu cuenta</p>

        <div class="space-y-4">

          <!-- Correo -->
          <div>
            <label class="block text-sm text-gray-700 mb-1.5">Correo electrónico</label>
            <label class="input w-full">
              <input type="email" placeholder="correo@ejemplo.com" class="grow" />
            </label>
          </div>

          <!-- Contraseña -->
          <div>
            <div class="flex items-center justify-between mb-1.5">
              <label class="text-sm text-gray-700">Contraseña</label>
              <button type="button"
                class="text-xs text-primary hover:opacity-80 font-medium transition-colors">
                ¿Olvidaste tu contraseña?
              </button>
            </div>
            <label class="input w-full">
              <input [type]="showPassword() ? 'text' : 'password'" placeholder="••••••••" class="grow" />
              <button type="button" (click)="showPassword.set(!showPassword())" class="text-base-content/40 hover:text-base-content/70 transition-colors">
                
                @if (showPassword()) {
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                  </svg>
                } @else {
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                }

              </button>
            </label>
          </div>

          <!-- Botón -->
          <button type="submit" routerLink="/dashboard"
            class="btn btn-primary w-full mt-2">
            Iniciar sesión
          </button>

        </div>

        <p class="text-center text-sm text-gray-500 mt-6">
          ¿No tienes cuenta?
          <a href="#" class="text-primary font-semibold hover:opacity-80 ml-1 transition-colors">
            Regístrate aquí
          </a>
        </p>

      </div>
    </div>
  </div>

</div>
